import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/components/FadeIn.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lander/src/components/JobAlertForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShinyButton"] */ "/vercel/path0/apps/lander/src/components/magicui/shiny-button.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.10_@babel+core@7.27.1_@opentelemetry+api@1.9.0_@playwright+test@1.54.1_react-_8dcd915e972dc0355f470e2078e8ebb8/node_modules/next/dist/client/app-dir/link.js");
